export const validateFileSize = (file, type) => {
   // 10MB for video, 5MB for images
  const sizeLimit = type === 'video' ? 10 * 1024 * 1024 : 5 * 1024 * 1024;
  const sizeError = file.size > sizeLimit ? `The ${type} size exceeds the limit of ${sizeLimit / (1024 * 1024)}MB.` : null;

  if (sizeError) return sizeError;

  // If the file is a video, validate its duration
  if(type === 'video') {
    return new Promise((resolve) => {
      const video = document.createElement('video');
      video.preload = 'metadata';

      video.onloadedmetadata = () => {
        window.URL.revokeObjectURL(video.src); 
        const duration = video.duration;
        if(duration > 30) {
          resolve('The video duration exceeds the limit of 30 seconds.');
        } else {
          resolve(null);
        }
      };

      video.onerror = () => {
        resolve('Failed to load video metadata for duration check.');
      };

      video.src = URL.createObjectURL(file);
    });
  }
  // Return null if there's no error and it's not a video
  return Promise.resolve(null);
};